import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import PageHeader from '../components/layout/PageHeader';

const HEADER_BG = 'https://images.unsplash.com/photo-1763568258314-24ef37bb52e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxJVCUyMHRlY2hub2xvZ3klMjBzb2Z0d2FyZSUyMGRldmVsb3BlciUyMGxhcHRvcCUyMGNvZGluZ3xlbnwwfHx8fDE3NzI0NDAyNjR8MA&ixlib=rb-4.1.0&q=85';
const API_URL = process.env.REACT_APP_BACKEND_URL;

const JoinTalentPool = () => {
  const [form, setForm] = useState({ full_name: '', email: '', phone: '', location: '', primary_skill: '', experience: '', availability: '', linkedin: '', summary: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API_URL}/api/talent-pool`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
    } catch (err) { console.error('Submit error:', err); }
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div data-testid="join-talent-pool-page">
      <PageHeader caption="Candidates" title="Join Talent Pool" subtitle="Submit your profile and get discovered by top enterprise clients." bgImage={HEADER_BG} />

      <section className="bg-white sol-section">
        <div className="sol-container">
          <div className="max-w-2xl mx-auto">
            <div className="bg-[#F5F5F5] p-8 md:p-12">
              {submitted ? (
                <div data-testid="talent-pool-success" className="text-center py-12">
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>Profile Submitted</h3>
                  <p className="text-[#525252] mb-6">Thank you for joining the Solnity Talent Pool. Our recruitment team will review your profile and reach out for suitable opportunities.</p>
                  <button onClick={() => { setSubmitted(false); setForm({ full_name: '', email: '', phone: '', location: '', primary_skill: '', experience: '', availability: '', linkedin: '', summary: '' }); }} className="sol-btn-outline text-sm">Submit Another Profile</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-testid="talent-pool-form">
                  <h3 className="text-xl font-semibold mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>Candidate Registration</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Full Name *</label><input name="full_name" value={form.full_name} onChange={handleChange} required className="sol-input" placeholder="Jane Doe" data-testid="talent-name-input" /></div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Email *</label><input name="email" type="email" value={form.email} onChange={handleChange} required className="sol-input" placeholder="jane@email.com" data-testid="talent-email-input" /></div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Phone</label><input name="phone" value={form.phone} onChange={handleChange} className="sol-input" placeholder="+1 (555) 000-0000" data-testid="talent-phone-input" /></div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Current Location *</label><input name="location" value={form.location} onChange={handleChange} required className="sol-input" placeholder="e.g. Toronto, Canada" data-testid="talent-location-input" /></div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Primary Skill / Technology *</label><input name="primary_skill" value={form.primary_skill} onChange={handleChange} required className="sol-input" placeholder="e.g. Java, Python, AWS" data-testid="talent-skill-input" /></div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Years of Experience *</label>
                      <select name="experience" value={form.experience} onChange={handleChange} required className="sol-select" data-testid="talent-exp-select">
                        <option value="">Select experience</option><option value="0-2">0-2 Years</option><option value="3-5">3-5 Years</option><option value="6-10">6-10 Years</option><option value="10+">10+ Years</option>
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">Availability</label>
                      <select name="availability" value={form.availability} onChange={handleChange} className="sol-select" data-testid="talent-availability-select">
                        <option value="">Select availability</option><option value="immediate">Immediate</option><option value="2-weeks">2 Weeks Notice</option><option value="1-month">1 Month Notice</option><option value="flexible">Flexible</option>
                      </select>
                    </div>
                    <div><label className="block text-sm font-medium text-[#333333] mb-2">LinkedIn Profile</label><input name="linkedin" value={form.linkedin} onChange={handleChange} className="sol-input" placeholder="https://linkedin.com/in/..." data-testid="talent-linkedin-input" /></div>
                  </div>
                  <div className="mb-6"><label className="block text-sm font-medium text-[#333333] mb-2">Professional Summary</label><textarea name="summary" value={form.summary} onChange={handleChange} className="sol-textarea" placeholder="Brief overview of your experience, key skills, and career objectives..." data-testid="talent-summary-input" /></div>
                  <button type="submit" disabled={loading} data-testid="talent-submit-btn" className="sol-btn-primary w-full text-sm">
                    {loading ? 'Submitting...' : 'Join Talent Pool'} <ArrowRight className="w-4 h-4" />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JoinTalentPool;
